import LazyHelper from '../helpers/lazy-helper';

const InitRelatedContent = {
    init: function () {
        document.addEventListener("DOMContentLoaded", function () {
            let isEventListenerAttached = false;
            if (getScrollFromTopValue() <= 0) {
                loadRelatedContentComponents();
            }
            else {
                isEventListenerAttached = true;
                window.addEventListener('scroll', loadRelatedContentComponents);
            }

            function loadRelatedContentComponents() {
                if (getScrollFromTopValue() <= 0) {
                    {
                        if (isEventListenerAttached) {
                            window.removeEventListener('scroll', loadRelatedContentComponents);
                        }

                        if(document.querySelector("#content-body-related-items.related-cherry-picked")) {
                            const elements = document.getElementsByClassName('components-data')[0].querySelectorAll('h2, hr');
                            elements.forEach(el => el.remove());
                        }
                        else if (!document.getElementById('related-content-script')) {
                            let ev1 = LazyHelper.addScriptFile('/Frontend-Assembly/SitefinityWebApp/Mvc/Scripts/RelatedContent/related-content.js', 'related-content-script', false);
                            ev1.onload = function () {
                                var data = document.getElementsByClassName('components-data')[0];

                                loadRelatedContentComponenets(
                                    data.getAttribute('data-numberOfItems'),
                                    data.getAttribute('data-strGuid'),
                                    data.getAttribute('data-mustache'),
                                    data.getAttribute('data-serviceUrl'),
                                    data.getAttribute('data-initialNumberOfItems'),
                                    data.getAttribute('data-culture'),
                                    data.getAttribute('data-fields'),
                                    data.getAttribute('data-minTermFreq'),
                                    data.getAttribute('data-preFilterSettings')
                                );
                            }
                        }
                    }
                }
            }

            function getScrollFromTopValue() {
                let components = document.getElementsByClassName('components-data');
                if (components.length > 0) {
                    return components[0].parentElement.getBoundingClientRect().top - 1000;
                }

                return 1;
            };
        });
    }
}

InitRelatedContent.init();